<div class="text-center mt-2" id="title-kp">
  <h5 class="text-uppercase"> Other Key Points Related to these Cities</h5>
</div>
<div class="d-block my-2 container m-0 -p-0 col col-xg-12 col-lg-12 col-md-12 col-xs-12 text-center ">
  <div class="card-deck">
  <!--- Tarjeta Superior Izquierda -->
  <div class="card card-inverse p-4">
    <div class="d-flex justify-content-between pl-3 pr-1 py-1 align-items-center">
      <span class="text-capitalize text-left"><h6>CAROLINA DEL NORTE</h6></span>
      <button type="button" class="btn btn-more col-2 p-0 align-self-start">More</button>
    </div>
    <div class="card-block pt-3">
      <div class="flex-row d-flex justify-content-between my-0">
            <div class="pl-3 py-0 text-left">
                <span class="text-capitalize text-left font-weight-bold ">In this season: &nbsp;
                    <i class="icon-block fa fa-sun" ></i>
                </span>
            </div>
            <div class="py-0 text-left">
                <span class="text-capitalize text-left font-weight-bold pl-2">Recommended: &nbsp;5
                    <i class="icon-block fa fa-moon "></i>
                </span>
            </div>
      </div>
      <div class="flex-column d-flex justify-content-between p-3 activities">
        <span class=" text-left"><span class="font-weight-bold"> Activities: </span> Terrestres - Acuaticas - Culturales -  Deportes Acuaticos - Puntos Turísticos -
        </span>
        <span class=" text-left"><span class="font-weight-bold"> This destinations can be covered in: </span>
          <i class="px-1 icon icon-car" aria-hidden="true"></i>
          <i class="px-1 icon icon-train-front" aria-hidden="true"></i>
          <i class="px-1 icon icon-vespa" aria-hidden="true"></i>
          <i class="px-1 icon icon-minibus" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div> 
  <!--- Tarjeta Superior Izquierda -->

  <!--- Tarjeta Superior Derecha -->
  <div class="card card-inverse p-4">
    <div class="d-flex justify-content-between pl-3 pr-1 py-1 align-items-center">
      <span class="text-capitalize text-left"><h6>MISSISIPI </h6></span>
      <button type="button" class="btn btn-more align-self-start col-2 p-0">More</button>
    </div>
    <div class="card-block pt-3">
      <div class="flex-row d-flex justify-content-between my-0">
            <div class="pl-3 py-0 text-left">
                <span class="text-capitalize text-left font-weight-bold ">In this season: &nbsp;
                    <i class="icon-block fa fa-sun" ></i>
                </span>
            </div>
            <div class="py-0 text-left">
                <span class="text-capitalize text-left font-weight-bold pl-2">Recommended: &nbsp;5
                    <i class="icon-block fa fa-moon "></i>
                </span>
            </div>
      </div>
      <div class="flex-column d-flex justify-content-between p-3 activities">
        <span class=" text-left"><span class="font-weight-bold"> Activities: </span> Terrestres - Acuaticas - Culturales -  Deportes Acuaticos - Puntos Turísticos -
        </span>
        <span class=" text-left"><span class="font-weight-bold"> This destinations can be covered in: </span>
          <i class="px-1 icon icon-car" aria-hidden="true"></i>
          <i class="px-1 icon icon-train-front" aria-hidden="true"></i>
          <i class="px-1 icon icon-vespa" aria-hidden="true"></i>
          <i class="px-1 icon icon-minibus" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
  <!--- Tarjeta Superior Derecha -->
  </div>
</div>
<div class="d-block container col col-xg-12 col-lg-12 col-md-12 col-xs-12 text-center ">
  <div class="card-deck">
    <!--- Tarjeta Inferior Izquierda -->
    <div class="card card-inverse p-4">
      <div class="d-flex justify-content-between pl-3 pr-1 py-1 align-items-center">
        <span class="text-capitalize text-left"><h6>NEW YORK </h6></span>
        <button type="button" class="btn btn-more align-self-start col-2 p-0">More</button>
      </div>
      <div class="card-block pt-3">
        <div class="flex-row d-flex justify-content-between my-0">
              <div class="pl-3 py-0 text-left">
                  <span class="text-capitalize text-left font-weight-bold ">In this season: &nbsp;
                      <i class="icon-block fa fa-sun" ></i>
                  </span>
              </div>
              <div class="py-0 text-left">
                  <span class="text-capitalize text-left font-weight-bold pl-2">Recommended: &nbsp;5
                      <i class="icon-block fa fa-moon "></i>
                  </span>
              </div>
        </div>
        <div class="flex-column d-flex justify-content-between p-3 activities">
          <span class=" text-left"><span class="font-weight-bold"> Activities: </span> Terrestres - Acuaticas - Culturales -  Deportes Acuaticos - Puntos Turísticos -
          </span>
          <span class=" text-left"><span class="font-weight-bold"> This destinations can be covered in: </span>
            <i class="px-1 icon icon-car" aria-hidden="true"></i>
            <i class="px-1 icon icon-train-front" aria-hidden="true"></i>
            <i class="px-1 icon icon-vespa" aria-hidden="true"></i>
            <i class="px-1 icon icon-minibus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
    <!--- Tarjeta Inferior Izquierda -->

    <!--- Tarjeta Inferior Derecha -->

    <div class="card card-inverse p-4">
      <div class="d-flex justify-content-between pl-3 pr-1 py-1 align-items-center">
        <span class="text-capitalize text-left"><h6>ORLANDO</h6></span>
        <button type="button" class="btn btn-more align-self-start col-2 p-0">More</button>
      </div>
      <div class="card-block pt-3">
        <div class="flex-row d-flex justify-content-between my-0">
              <div class="pl-3 py-0 text-left">
                  <span class="text-capitalize text-left font-weight-bold ">In this season: &nbsp;
                      <i class="icon-block fa fa-sun" ></i>
                  </span>
              </div>
              <div class="py-0 text-left">
                  <span class="text-capitalize text-left font-weight-bold pl-2">Recommended: &nbsp;5
                      <i class="icon-block fa fa-moon "></i>
                  </span>
              </div>
        </div>
        <div class="flex-column d-flex justify-content-between p-3 activities">
          <span class=" text-left"><span class="font-weight-bold"> Activities: </span> Terrestres - Acuaticas - Culturales -  Deportes Acuaticos - Puntos Turísticos -
          </span>
          <span class=" text-left"><span class="font-weight-bold"> This destinations can be covered in: </span>
            <i class="px-1 icon icon-car" aria-hidden="true"></i>
            <i class="px-1 icon icon-train-front" aria-hidden="true"></i>
            <i class="px-1 icon icon-vespa" aria-hidden="true"></i>
            <i class="px-1 icon icon-minibus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
      <!--- Tarjeta Inferior Derecha -->
  </div>
</div>
